var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.18172C7.33301 9.54991 7.63148 9.84839 7.99967 9.84839C8.36786 9.84839 8.66634 9.54991 8.66634 9.18172V5.18172C8.66634 4.81353 8.36786 4.51505 7.99967 4.51505C7.63148 4.51505 7.33301 4.81353 7.33301 5.18172V9.18172Z",
    fill: "#EA7373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12.4672C7.63148 12.4672 7.33301 12.1687 7.33301 11.8005C7.33301 11.4323 7.63148 11.1339 7.99967 11.1339C8.36786 11.1339 8.66634 11.4323 8.66634 11.8005C8.66634 12.1687 8.36786 12.4672 7.99967 12.4672Z",
    fill: "#EA7373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 15.168C4.31778 15.168 1.33301 12.1832 1.33301 8.5013C1.33301 4.8194 4.31778 1.83463 7.99967 1.83463C11.6816 1.83463 14.6663 4.8194 14.6663 8.5013C14.6663 12.1832 11.6816 15.168 7.99967 15.168ZM2.66634 8.5013C2.66634 5.55578 5.05416 3.16797 7.99967 3.16797C10.9452 3.16797 13.333 5.55578 13.333 8.5013C13.333 11.4468 10.9452 13.8346 7.99967 13.8346C5.05416 13.8346 2.66634 11.4468 2.66634 8.5013Z",
    fill: "#EA7373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWarning);
export default __webpack_public_path__ + "static/media/info_warning.76236fea86a4bb889218fc0a29aab129.svg";
export { ForwardRef as ReactComponent };